export default __webpack_public_path__ + "static/media/vip-toilet.e8c0e507.jpg";